import { useEffect } from "react"

import { ROLE_EXTERNAL_ADMIN } from "shared/constant/lookup/role"
import useFetch from "shared/model/useFetch"
import useRoleCookie from "shared/model/useRoleCookie"

const useGetExternalAdminEvent = () => {
    const [roleCookie] = useRoleCookie()
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        if ([ROLE_EXTERNAL_ADMIN].includes(roleCookie)) {
            fetchRequest("GET", `/external-admin/event/list/active `)
        }
    }, [])

    return [fetchResult]
}

export default useGetExternalAdminEvent